const InvestmentsOverviewFactory = function ($resource, $http, $window) {
    return {
        getOverview: function (data) {
            const req = {
                url:
                    __baseApiUrl__ +
                    "/participant-web-services/rest/investments/services/" +
                    data.individualId +
                    "/" +
                    data.groupId +
                    "/overview",
                method: "GET",
                isArray: false,
                crossDomain: true,
                headers: {
                    "Content-Type": "application/json"
                }
            };
            return $http(req);
        },
        getLiatOverview: function (data) {
            const req = {
                url:
                    __baseApiUrl__ +
                    "/participant-web-services/rest/investments/services/retirementincome/" +
                    data.individualId +
                    "/" +
                    data.groupId +
                    "/overview",
                method: "GET",
                isArray: false,
                crossDomain: true,
                headers: {
                    "Content-Type": "application/json"
                }
            };
            return $http(req);
        },
        getOverviewBasic: function (data) {
            const req = {
                url:
                    __baseApiUrl__ +
                    "/participant-web-services/rest/investments/services/" +
                    data.individualId +
                    "/" +
                    data.groupId +
                    "/guidanceInfo",
                method: "GET",
                isArray: false,
                crossDomain: true,
                headers: {
                    "Content-Type": "application/json"
                }
            };
            return $http(req);
        }
    };
};

InvestmentsOverviewFactory.$inject = ["$resource", "$http", "$window"];
export default InvestmentsOverviewFactory;
